import React, { useMemo, useState } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, StepperItem } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'

const steps = [
  "Pending", "Actioned"
]

const ActionField = ( record ) => {
    return (
      <div onClick={async () => {
        await localStorage.setItem( "link", "display" )
        await localStorage.setItem( "applicationId", record.value )
        await localStorage.setItem( "application_action", "APPROVER" )
        return window.location.reload()
      } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
}

const ProgressField = record => {
    console.log( '%',record.value )
    return (
      <div className="flex w-full items-center justify-center">
        <ProgressBar value={record.value}/>
        <div className="text-xs mx-2">
            {`${record.value}%`}
        </div>
      </div>
    )
}

const MenuItemLink = ( { label, icon, spaced, slug } ) => {
  const handleNavigate = async () => {
      await localStorage.setItem( "link", slug )
      return window.location.reload()
  }
  return (
      <button type="button" onClick={handleNavigate} className={`flex h-full border-gray-200 hover:bg-green-300 hover:font-bold hover:text-black ${ spaced } `}>
          <div className="h-full w-full flex items-center justify-center">
              <span>{icon}</span>
              <span className="text-lime-400 text-xs md:text-xs lg:text-xs">{label}</span>
          </div>
      </button>
  )
}

export default function AllRegistration( { product } ) {
  const ApplicationColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "S.No",
      accessor: "sno"
    },
    {
      Header: "Business Trading Name",
      accessor: "applicant"
    },
    {
      Header: "Date Applied",
      accessor: "date"
    },
    {
      Header: "Annual Income",
      accessor: "annual_income"
    },
    {
      Header: "Application Progress",
      accessor: "progress",
      Cell: ProgressField
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ActionField
    }
  ] )
  
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ tag, setTag ] = useState( "Pending" )
  const [itcoApplicationsLevel, setItcoApplicationsLevel] = useState('0'); 
  const [ levelRecords, setLevelRecords ] = useState( [] )

  React.useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading, itcoApplicationsLevel ])

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            id: result.id
        }
       } )

       //update the state
       setRecords( results )
       //setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      //setLoading( false )
    }
  }

  const fetchLevelApplications = async (itcoApplicationsLevel) => {
    try {
      console.log("fetching based on level ==> " +itcoApplicationsLevel)
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication/`+itcoApplicationsLevel+`/level` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            id: result.id
        }
       } )

       //update the state
       setLevelRecords( results )
       //setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      //setLoading( false )
    }
  }

  const handleResults = ( values ) => {
    //if(localStorage.getItem( "role" )?.toUpperCase().includes("APPROVER")){
      //return values.filter( item => (parseInt( item.stage ) === 8 || parseInt( item.stage ) === 9 ) )

      return values.filter( item => {
        if( tag?.toLowerCase() === "pending" ) {
          //console.log("caught pending")
          return (parseInt( item.stage ) === 8 )
        }
        if( tag?.toLowerCase() === "actioned" ) {
          return parseInt( item.stage ) == 9
        }
      })
    //}
  }
 
  const updateItcoApplicationsLevel = (data) => {
    setItcoApplicationsLevel(data);
    fetchLevelApplications(itcoApplicationsLevel)
  };

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip updateItcoApplicationsLevel={updateItcoApplicationsLevel} />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`All Applications IT Service Providers`}
            </div>
            <div className="flex flex-col justify-center w-full bg-white">
              <div className="w-full flex flex-row border-b border-gray-500 rounded-sm">
                {/* tabs */}
                {steps.map( ( item, index ) => {
                  return (
                  <StepperItem 
                    edge={index === 0} 
                    active={tag.toUpperCase() === item?.toUpperCase()} 
                    key={item} 
                    label={item} 
                    onPress={() => {
                      return setTag( item )
                    } } />
                  )
                } )}
                </div>
                <Table 
                  rightButton={false}
                  rightBtnCallback={ () => {}}
                  rightButtonLabel={null}
                  label="Application Details"
                  columns={ApplicationColumns}
                  data={itcoApplicationsLevel === "0" ? handleResults(records) : levelRecords}
                  hidePagination={false}
                  exportToExcel={() => {}}
                  exportToCSV={() => {}}
                />
            </div>
          </div>
        </div>
    </Wrapper>
  )
}